(function userCredentials(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousUserCredentialsModule = global.NewHomeSource.UserCredentials;
  /**
  * @constructs NewHomeSource.userCredentials
  */
  function UserCredentials() {
  }

  /**
  * @public
  * get the status of user session
  */
  UserCredentials.isUserLogged = function () {
    return !!document.querySelector('[data-user-credentials]');
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.userCredentials to the previous script.
  */
  UserCredentials.noConflict = function noConflict() {
    global.NewHomeSource.UserCredentials = previousUserCredentialsModule;
    return UserCredentials;
  };

  global.NewHomeSource.UserCredentials = UserCredentials;

  return UserCredentials;
}(window));
